import React, { useState } from 'react';
import InterviewScheduleDetails from './InterviewDetails';
import UnAvailableReasons from './UnavailableReasons';
import '../../../css/Form.css';
import ApiGateway from '../../../helper/ApiGateway';
import ERPUtils from '../../../helper/Utils';
import useStateCallback from '../../../helper/asyncSetState';
import Loader from '../../../helper/Loader';
import Popup from '../../../helper/SuccessPopup';
import { toast } from 'react-toastify';

const ThirdRound = (props) => {
	const { interviewDetails, ActiveInterviewRound, closeInterviewModal, getApplicationsData, savedData } = props;

	//Loader:
	const [LoaderActive, setLoaderActive] = useStateCallback(false);
	// Popup state;
	const [showAlert, setShowAlert] = useStateCallback(false);
	// const [warningMsg, setWarmingMsg] = useState(false);
	const [requiredFieldsAlert, showRequiredFieldsAlert] = useState(false);
	const [ApiError, setApiError] = useState(false);
	// Component State:
	const [ReasonsForRej, setReasonsForRej] = useStateCallback([]); // DropDown Data
	const [roundData, setRoundData] = useStateCallback({
		availableForInt: ERPUtils.isUndefinedOrNull(savedData) === false ? savedData.isAvailableForTheInterview : '',
		RejectionReason: '',
		otherReason: ''
	}); 

	const [RequiedFields, setRequiredFields] = useStateCallback({
		availableForIntReqError: false,
		RejectionReasonReqError: false,
		otherReasonReqError: false
	});

	// Handlers:
	const onChangeHandler = (event) => {
		const name = event.target.name;
		const val = event.target.value;
		let oldObj = { ...roundData };
		if (name === 'availableForInt') {
			if (val === 'true') {
				oldObj[name] = val;
				oldObj['RejectionReason'] = '';
				setRoundData(oldObj, () => {
					changeRequiredStatus('availableForInt');
				});
			} else if (val === 'false') {
				oldObj[name] = val;
				setRoundData(oldObj, () => {
					ReasonsApi();
					changeRequiredStatus('availableForInt');
				});
			}
		} else {
			oldObj[name] = val;
			setRoundData(oldObj);
			changeRequiredStatus(name);
		}
	};

	const selectHandler = (selected) => {
		const oldObj = { ...roundData };
		oldObj['RejectionReason'] = selected;
		oldObj['otherReason'] = '';
		setRoundData(oldObj);
		changeRequiredStatus('RejectionReason');
		if (selected.isReschedulable === true) {
			setShowAlert(true);
		} 
	};

	const changeRequiredStatus = (target) => {
		const oldObj = { ...RequiedFields };
		if (target === 'availableForInt') {
			oldObj['availableForIntReqError'] = false;
			oldObj['RejectionReasonReqError'] = false;
			oldObj['otherReasonReqError'] = false;
		}
		if (target === 'RejectionReason') {
			oldObj['RejectionReasonReqError'] = false;
			oldObj['otherReasonReqError'] = false;
		}
		if (target === 'otherReason') {
			oldObj['otherReasonReqError'] = false;
		}
		setRequiredFields(oldObj);
	};

	const CheckRequiredErrors = () => {
		const checkThese = ['availableForInt'];
		const ReqErrors = { ...RequiedFields };
		const available = {
			RejectionReason:
				roundData.availableForInt !== '' ? (roundData.availableForInt === 'false' ? true : false) : false,
			otherReason:
				roundData.RejectionReason !== '' ? (roundData.RejectionReason.label === 'Other' ? true : false) : false
		};

		checkThese.map((el) => {
			if (
				ERPUtils.isUndefinedOrNull(roundData[el]) === true ||
				ERPUtils.isNullOrEmpty(roundData[el]) === true ||
				ERPUtils.isNullorWhiteSpace(roundData[el]) === true
			) {
				let name = el + 'ReqError';
				ReqErrors[name] = true;
			} else {
				let name = el + 'ReqError';
				ReqErrors[name] = false;
			}
			return ''
		});

		Object.keys(available).map((el) => {
			if (available[el]) {
				if (
					ERPUtils.isUndefinedOrNull(roundData[el]) === true ||
					ERPUtils.isNullOrEmpty(roundData[el]) === true ||
					ERPUtils.isNullorWhiteSpace(roundData[el]) === true
				) {
					let name = el + 'ReqError';
					ReqErrors[name] = true;
				} else {
					let name = el + 'ReqError';
					ReqErrors[name] = false;
				}
			} else {
				let name = el + 'ReqError';
				ReqErrors[name] = false;
			}
			return ''
		});
		setRequiredFields(ReqErrors, () => {
			checkForErrors(ReqErrors);
		});
	};

	const checkForErrors = (data) => {
		var allVals = [];
		Object.keys(data).map((el) => {
			allVals.push(data[el]);
			return '';
		});
		if (allVals.indexOf(true) !== -1) {
			RequiredFieldsAlert();
		} else {
			submitData();
		}
		return '';
	};

	// To show required fields error popup
	const RequiredFieldsAlert = () => {
		showRequiredFieldsAlert(!requiredFieldsAlert);
	};
	// Reschedule popup
	const hideAlert = () => {
		setShowAlert(false);
	};

	// To Close the error popup
	const closeErrorPopup = () => {
		setApiError(false);
	};

	// Rejection popup
	// const warningHanlder = () => {
	// 	setWarmingMsg(false);
	// };

	// Api handlers:
	const ReasonsApi = () => {
		setLoaderActive(true);
		let url = 'Employee/CommonEmployee/getApplnNonAvailability?interviewRound=';
		let interviewRound =
			ERPUtils.isUndefinedOrNull(ActiveInterviewRound.interviewRound) === false
				? ActiveInterviewRound.interviewRound
				: '';
		ApiGateway.post(url + interviewRound, {}, (response) => {
			try {
				setLoaderActive(false);
				if (ERPUtils.isUndefinedOrNull(response) === false) {
					try {
						if (response.status === 'SUCCESS') {
							let newArray=[]
							let otherObj={ value: 'Other', label: 'Other' }
							newArray=!ERPUtils.isUndefinedOrNull(response?.data?.dto) ? response?.data?.dto : []
							newArray.push(otherObj)
							 setReasonsForRej(newArray);
							 setLoaderActive(false);
						  }
						else {
							setLoaderActive(false);
						}
					} catch (ex) { setLoaderActive(false);}
				}
			} catch (ex) {
				setLoaderActive(false);
			}
		});
	};

	const submitData = () => {
		var ApiData = {
			empApplnEntriesId:
				ActiveInterviewRound.empApplnEntriesId !== undefined ? ActiveInterviewRound.empApplnEntriesId : null,
			applicationNo: ActiveInterviewRound.applicationNo !== undefined ? ActiveInterviewRound.applicationNo : null,
			empApplnInterviewSchedulesId:
				ActiveInterviewRound.empApplnInterviewSchedulesId !== undefined
					? ActiveInterviewRound.empApplnInterviewSchedulesId
					: null,
			interviewRound:
				ActiveInterviewRound.interviewRound !== undefined ? ActiveInterviewRound.interviewRound : null,
			isAvailableForTheInterview: roundData.availableForInt,
			empApplnNonAvailabilityDTO:
				roundData.availableForInt === 'true'
					? null
					: roundData.RejectionReason.label === 'Other'
						? {
							empApplnNonAvailabilityId: null,
							nonAvailabilityName: roundData.otherReason,
							isReschedulable: null,
							interviewRound:
								ActiveInterviewRound.interviewRound !== undefined
									? ActiveInterviewRound.interviewRound
									: null
						}
						: {
							empApplnNonAvailabilityId: roundData.RejectionReason.value,
							nonAvailabilityName: roundData.RejectionReason.label,
							isReschedulable: roundData.RejectionReason.isReschedulable,
							interviewRound: roundData.RejectionReason.interviewRound
						}
		};
		setLoaderActive(true);
		let url = 'Employee/Recruitment/EmployeeApplicationControler/submitEmployeeApplicationInterviewDetails';
		ApiGateway.post(url, ApiData, (response) => {
			try {
				setLoaderActive(false);
				if (ERPUtils.isUndefinedOrNull(response) === false) {
					try {
						if (response.status === 'SUCCESS') {
							toast.success("Data Submitted Successfully")
							getApplicationsData();
						} else {
							setLoaderActive(false);
						}
					} catch (ex) { }
				}
			} catch (ex) {
				setLoaderActive(false);
			}
		});
	};

	return (
		<div>
			<div style={{ height:"auto", overflow:"auto"}}>
				<InterviewScheduleDetails interviewDetails={interviewDetails} />

				<div className="parentBoxDiv border">
					<div className="childBoxDiv box sub">
						<div className="row" style={{ paddingLeft: '10px' }}>
							<div className="col-md-4 col-xs-12">
								<label className="formExpLabel">
									<span className="requiredText">*</span>
									Available for the interview
								</label>
							</div>
							<div className="col-md-5" style={{ top: '13px' }}>
								<label className="radio-inline">
									<input
										className="space"
										onChange={onChangeHandler}
										type="radio"
										name="availableForInt"
										value="true"
										checked={roundData.availableForInt === 'true'}
										disabled={interviewDetails.editable === false ? true : false}
									/>
									Yes
								</label>
								<label className="radio-inline">
									<input
										className="space"
										onChange={onChangeHandler}
										type="radio"
										name="availableForInt"
										value="false"
										checked={roundData.availableForInt === 'false'}
										disabled={interviewDetails.editable === false ? true : false}
									/>
									No
								</label>
								{RequiedFields.availableForIntReqError ? (
									<p className="RoundValidationError">
										<i className="fa fa-warning warningIcon" />&nbsp; This field can't be empty
									</p>
								) : null}
							</div>
						</div>
					</div>
				</div>

				{roundData.availableForInt === 'false' ? (
					<UnAvailableReasons
						selectHandler={selectHandler}
						ReasonsData={roundData.RejectionReason}
						ReasonsForRej={ReasonsForRej}
						otherReason={roundData.otherReason}
						onChangeHandler={onChangeHandler}
						RequiedFields={RequiedFields}
						interviewDetails={interviewDetails}
					/>
				) : null}

			</div>

			{interviewDetails.editable === false ? null : (
				<div className="buttonsParentTab">
					<div className="row buttonsChildTab">
						<div className="col d-flex justify-content-center text-center pt-1 pb-2 ">
							<button
								className="myButton DashboardSubmitBtn z-depthButton"
								value="Previous"
								name="PersonalDetails"
								onClick={CheckRequiredErrors}
							>
								Submit
							</button>
							<button
								className="myButton DashBoardCancel z-depthButton"
								name="cancel"
								onClick={closeInterviewModal}
							>
								Cancel
							</button>
						</div>
					</div>
				</div>
			)}
			{LoaderActive ? <Loader open={LoaderActive} LoaderType={1} /> : null}
			{showAlert ? (
				<Popup
					open={showAlert}
					close={hideAlert}
					msg="We will reschedule the interview and update you the details accordingly."
					icon={<i className="fa fa-check successIcon" aria-hidden="true" />}
				/>
			) : null}
			{/* {warningMsg ? (
				<Popup
					open={warningMsg}
					close={warningHanlder}
					title="Warning!"
					msg="We will reschedule the interview and update you the details accordingly."
				// icon={<i className="fa fa-exclamation ConfirmWarningIcon" />}
				/>
			) : null} */}
			{ApiError ? (
				<Popup
					open={ApiError}
					close={closeErrorPopup}
					msg="Error! occourred while loading the data."
					title="Sorry! for the inconvenience occourred"
					icon={<i className="fa fa-times-circle" style={{ fontSize: '48px', color: '#D9291B' }} />}
					success={false}
					hint="Note: Please try again."
					tabName=""
				/>
			) : null}
			{requiredFieldsAlert ? (
				<Popup
					open={requiredFieldsAlert}
					close={RequiredFieldsAlert}
					msg="Some of the Required fields are missing."
					title="Error!"
					icon={<i className="fa fa-times-circle" style={{ fontSize: '48px', color: '#D9291B' }} />}
					success={false}
					tabName=""
				/>
			) : null}
		</div>
	);
};

export default ThirdRound;
